<section>
  <div class="cg-inner-page-wrapper header-content">
    <div>
      <a *ngIf="isLogoLinkInternal && logoLink" [routerLink]="logoLink">
        <ng-container *ngTemplateOutlet="logo"></ng-container>
      </a>
      <a *ngIf="!isLogoLinkInternal && logoLink" [href]="logoLink">
        <ng-container *ngTemplateOutlet="logo"></ng-container>
      </a>
      <ng-container *ngIf="!logoLink">
        <ng-container *ngTemplateOutlet="logo"></ng-container>
      </ng-container>

      <ng-template #logo>
        <cigna-evernorth-logo [color]="'tempermint'"></cigna-evernorth-logo>
      </ng-template>
    </div>
    <div style="margin-left: auto" class="cg-flex-vertical-center">
      <div class="header-search-wrapper">
        <cigna-evernorth-search
          [isResourcesPage]="isResourceLibraryApp"
          [isSecure]="isAuthenticated"
        ></cigna-evernorth-search>
      </div>

      <ng-container
        *ngIf="
          !isResourceLibraryApp && isAuthenticated && !isNavigationDisabled
        "
      >
        <div class="cg-margin-left-lg">
          <button
            (click)="logOut.emit({ variation: 'logout', linkName: 'Logout' })"
            data-test-id="button-logout"
            cignaButton="link"
            class="header-link"
          >
            Logout
          </button>
        </div>

        <div class="cg-margin-left-lg">
          <cigna-evernorth-header-util
            [firstName]="firstName"
            [lastName]="lastName"
            [userid]="userid"
            [profileLinks]="profileLinks"
            [isImpersonator]="isImpersonator"
            [isMessageCenterEnabled]="isMessageCenterEnabled"
          ></cigna-evernorth-header-util>
        </div>
      </ng-container>
    </div>
  </div>
</section>
